import { render, staticRenderFns } from "./DocumentTemplateListFilter.vue?vue&type=template&id=3bc8a88b&scoped=true&"
import script from "./DocumentTemplateListFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8a88b",
  null
  
)

export default component.exports